import { Grid, Typography } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import {
  Button,
  Edit,
  FormTab,
  List,
  TabbedForm,
  TopToolbar
} from 'react-admin';
import { FormSpy } from 'react-final-form';

import EditToolbar from '../../core/components/edit/EditToolbar';
import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import Empty from '../../core/components/list/Empty';
import { ListPagination } from '../../core/components/list/ListPagination';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import { getInitials, removePathEnd } from '../../core/utils';
import CategorySummary from './CategorySummary';
import SubcategoriesDatagrid from './SubcategoriesDataGrid';
import SubcategoryCreateDialog from './SubcategoryCreateDialog';
import ViewTab from '../../core/components/forked/layout/ViewTab';

const styles = () => ({
  gridTab: {
    marginTop: '-17px !important'
  },
  noActions: {
    marginTop: '0px'
  }
});

const SubcategoryActionStyles = {
  addButton: {
    border: '1px solid #E0E0E0',
    background: 'white',
    alignSelf: 'center'
  },
  headline: {}
};

const CategoryTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.name}
      status={record.status}
      statusLabel="Status:"
      showAvatar={true}
      avatarContent={getInitials(record.name)}
    />
  );
};

const SubcategoryAction = withStyles(SubcategoryActionStyles)(
  ({
    classes,
    handleSubcategoryCreateDialogToggle,
    hasWriteCategorySubcategoryPermission
  }) => (
    <Grid container justifyContent="space-between" alignItems="center">
      <Typography variant="h5" className={classes.headline}>
        Subcategories
      </Typography>
      <TopToolbar>
        {hasWriteCategorySubcategoryPermission && (
          <Button
            onClick={handleSubcategoryCreateDialogToggle}
            label="Create Subcategory"
            variant="outlined"
            color="primary"
            className={classes.addButton}
            disableFocusRipple
          />
        )}
      </TopToolbar>
    </Grid>
  )
);

class CategoryEdit extends React.Component {
  state = {
    showSubcategoryCreateDialog: false,
    showSubcategoryEditDialog: false,
    subcategoryRecord: {},
    whenBlockNavigation: false
  };

  handleSubcategoryCreateDialogToggle = () => {
    this.setState(prevState => {
      return {
        showSubcategoryCreateDialog: !prevState.showSubcategoryCreateDialog
      };
    });
  };

  handleSubcategoryEditDialogToggle = () => {
    this.setState(prevState => {
      return {
        showSubcategoryEditDialog: !prevState.showSubcategoryEditDialog
      };
    });
  };

  handleSubcategoryEditButtonClick = (
    subcategoryRecord,
    subcategoryBasePath
  ) => {
    this.setState(prevState => {
      return {
        showSubcategoryEditDialog: !prevState.showSubcategoryEditDialog,
        subcategoryRecord,
        subcategoryBasePath
      };
    });
  };

  onBeforeDelete = () => {
    // Unblock navigation before deleting
    this.setState({
      whenBlockNavigation: false
    });
  };

  handleFormIsDirty(dirty) {
    // Block navigation if the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  }

  render() {
    const {
      showSubcategoryCreateDialog,
      showSubcategoryEditDialog,
      subcategoryRecord,
      subcategoryBasePath,
      whenBlockNavigation
    } = this.state;
    const {
      classes,
      dispatch,
      hasCreatePermission,
      hasEditPermission,
      hasDeletePermission,
      permissions = [],
      userProfile,
      ...rest
    } = this.props;
    const displayToolbar = this.props.match.isExact;
    const hasWriteCategorySubcategoryPermission = permissions.includes(
      'AUTH_WRITE_CATEGORY_SUBCATEGORY'
    );

    return (
      <React.Fragment>
        <NavigationPrompt
          when={whenBlockNavigation}
          adjustMatchingPath={removePathEnd}
          hasEditPermission={hasEditPermission}
        >
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Edit
          {...rest}
          undoable={false}
          title={<CategoryTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TabbedForm
            toolbar={
              displayToolbar ? (
                <EditToolbar
                  {...rest}
                  hasEditPermission={hasEditPermission}
                  hasDeletePermission={hasDeletePermission}
                  onBeforeDelete={this.onBeforeDelete}
                />
              ) : (
                <></>
              )
            }
            variant="standard"
            margin="normal"
          >
            <FormTab label="Category Details">
              <CategorySummary creation={false} />
              <FormSpy
                subscription={{ dirty: true }}
                onChange={props => {
                  const self = this;
                  setTimeout(() => self.handleFormIsDirty(props.dirty), 1);
                }}
              />
            </FormTab>
            <ViewTab label="Subcategories">
              <List
                {...rest}
                style={{ margin: '0px', width: '100%' }}
                pagination={<ListPagination />}
                filter={{
                  categoryId: this.props.id,
                  orphanVisibility: 'ALL_VISIBLE'
                }}
                className={classes.gridTab}
                sort={{ field: 'name', order: 'ASC' }}
                basePath="/subcategories"
                resource="subcategories"
                title=" "
                actions={
                  <SubcategoryAction
                    handleSubcategoryCreateDialogToggle={
                      this.handleSubcategoryCreateDialogToggle
                    }
                    hasWriteCategorySubcategoryPermission={
                      hasWriteCategorySubcategoryPermission
                    }
                  />
                }
                bulkActionButtons={false}
                empty={
                  <Empty
                    emptyText="There are no Subcategories to be displayed"
                    title="Subcategories"
                    buttons={[
                      {
                        label: 'Create Subcategory',
                        onClick: this.handleSubcategoryCreateDialogToggle,
                        hide: !hasWriteCategorySubcategoryPermission
                      }
                    ]}
                  />
                }
              >
                <SubcategoriesDatagrid
                  handleSubcategoryEditButtonClick={
                    this.handleSubcategoryEditButtonClick
                  }
                  hasWriteCategorySubcategoryPermission={
                    hasWriteCategorySubcategoryPermission
                  }
                />
              </List>
              <SubcategoryCreateDialog
                {...rest}
                operation="Update"
                title=" "
                popupTitle="Edit Subcategory"
                okButtonLabel="Save"
                showDialog={showSubcategoryEditDialog}
                categoryId={this.props.id}
                handleDialogToggle={this.handleSubcategoryEditDialogToggle}
                subcategoryId={subcategoryRecord.id}
                basePath={subcategoryBasePath}
                resource="subcategories"
              />
              <SubcategoryCreateDialog
                {...rest}
                operation="Create"
                title=" "
                popupTitle="Add Subcategory"
                okButtonLabel="Add"
                categoryId={this.props.id}
                showDialog={showSubcategoryCreateDialog}
                handleDialogToggle={this.handleSubcategoryCreateDialogToggle}
              />
            </ViewTab>
          </TabbedForm>
        </Edit>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CategoryEdit);
